/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FormControl, TextField, TextFieldProps } from '@mui/material';
import { Controller, RegisterOptions } from 'react-hook-form';

export type InputProps = TextFieldProps & {
  name: string;
  label: string;
  control: any;
  minWidth?: string;
  maxWidth?: string;
  defaultValue?: string;
  rules?: RegisterOptions;
};

export function MuiInput({
  name,
  label,
  minWidth,
  maxWidth,
  defaultValue,
  // sx,
  inputProps,
  control,
  rules,
  ...textFieldProps
}: InputProps) {
  return (
    <FormControl
      sx={{
        minWidth: minWidth ? minWidth : '200px',
        maxWidth: maxWidth ? maxWidth : '200px',
      }}
      variant="outlined"
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue ?? ''}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            {...textFieldProps}
            helperText={error ? error.message : null}
            size="medium"
            error={!!error}
            onChange={onChange}
            value={value}
            fullWidth
            label={label}
            variant="outlined"
            inputProps={{ ...inputProps }}
            sx={{
              fontSize: '1rem',
              mt: 2,
              background: textFieldProps.disabled ? '#F2F2EF' : 'transparent',
            }}
          />
        )}
      />
    </FormControl>
  );
}
